import React, { useState } from 'react';
import styles from 'Containers/ContactForm/LeadForm/styles.scss';
import Check from 'Components/Check';
import Button from 'Components/Button';
import Link from 'Components/Link';

export const AdvertisementCommunicationInfo = ({
  dealer,
  errors,
  emailOptIn,
  setEmailOptIn,
  setTelephoneOptIn,
  telephoneOptIn,
  resize,
  optionsAvailable = true,
}) => {
  const [showLegal, setShowLegal] = useState(false);
  const legalId = 'advertisement-communication-info-legal';

  return (
    <div className={styles.stackColumn}>
      <div className={styles.lightGrey}>
        Diese Website ist durch reCAPTCHA geschützt und es gelten die{' '}
        <Link
          to="https://policies.google.com/privacy"
          target="_blank"
          isExternal
          label="Datenschutzbestimmungen"
        />{' '}
        und{' '}
        <Link
          to="https://policies.google.com/terms"
          target="_blank"
          isExternal
          label="Nutzungsbedingungen"
        />{' '}
        von Google.
      </div>

      <div className={styles.lightGrey}>
        <Button
          variant="secondary"
          upperCase={false}
          label="Informationen zur werblichen Kommunikation und Widerrufsmöglichkeit"
          ariaExpanded={showLegal}
          ariaControls={legalId}
          onClick={(e) => {
            e.preventDefault();
            setShowLegal((cur) => !cur);
            if (resize) {
              window.setTimeout(resize, 150);
            }
          }}
        />
      </div>

      {showLegal && (
        <div id={legalId} className={styles.lightGrey}>
          Ich bin damit einverstanden, dass der Mazda Vertragshändler {dealer.name} und/oder die
          Mazda Motors (Deutschland) GmbH, Hitdorfer Straße 73, D-51371 Leverkusen, meine
          persönlichen Daten zu Zwecken von Direktmarketing von Produkten und Services der Marke
          Mazda (z.B. Kundeninfos, Reifenwechsel, HU/AU Fälligkeit, Serviceaktionen) sowie für
          Zwecke der Kundenzufriedenheitsbefragungen nutzt. Mit dem Abonnement des Newsletters
          erkläre ich mich ebenfalls mit der Analyse durch individuelle Auswertung von Öffnungs- und
          Klickraten einverstanden. Die Einwilligung kann ich jederzeit ganz oder teilweise durch
          Erklärung per E-Mail an: info@mazda.de, telefonisch unter 02173-943121 und über den
          Abmeldelink in den E-Mails widerrufen.
          <br />
          Ein getrennter Widerruf der Einwilligung zum Setzen des Tracking Pixel ist aus technischen
          Gründen leider nicht möglich, in diesem Fall muss das gesamte Newsletterabonnement
          gekündigt, bzw. muss ihm widersprochen werden. <br />
          <br />
          Gegenüber dem Autohaus erklärte Einwilligungen können jederzeit über die aus dem{' '}
          <Link to="/impressum" target="blank" label="Impressum" /> ersichtlichen Kontaktdaten von{' '}
          {dealer.name} widerrufen werden.
        </div>
      )}

      {optionsAvailable && (
        <ul className={styles.unorderedList}>
          <li>
            <Check
              name="emailOptIn"
              label="Ich willige in die werbliche Kommunikation per E-Mail ein"
              value={emailOptIn}
              checked={emailOptIn}
              errorMessage={errors.emailOptIn === 'init' ? '' : errors.emailOptIn}
              onChange={setEmailOptIn}
            />
          </li>
          <li>
            <Check
              name="telephoneOptIn"
              label="Ich willige in die werbliche Kommunikation per Telefon ein"
              value={telephoneOptIn}
              checked={telephoneOptIn}
              errorMessage={errors.telephoneOptIn === 'init' ? '' : errors.telephoneOptIn}
              onChange={setTelephoneOptIn}
            />
          </li>
        </ul>
      )}

      <div className={styles.lightGrey}>
        Bitte beachten Sie daneben auch Ihre Widerrufs- und Änderungsmöglichkeiten im{' '}
        <Link to="/cookies" target="_blank" label="Datenschutz-Präferenzcenter" /> sowie die
        aktuellen <Link to="/datenschutz" target="_blank" label="Informationen zum Datenschutz" />.
      </div>
    </div>
  );
};
